import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  const colorMap: Record<string, { bg: string; icon: string; border: string }> = {
    primary: { bg: 'bg-primary-100', icon: 'text-primary-600', border: 'hover:border-primary-300/60' },
    accent: { bg: 'bg-accent-100', icon: 'text-accent-600', border: 'hover:border-accent-300/60' },
    secondary: { bg: 'bg-secondary-100', icon: 'text-secondary-600', border: 'hover:border-secondary-300/60' },
  };

  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">内容频道</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">各大数字站点精品资源分类速览</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((card, idx) => {
            const colors = colorMap[card.color] || colorMap.primary;
            return (
              <div
                key={idx}
                className={`group p-6 bg-background-50 rounded-lg border border-background-200/60 transition-all cursor-pointer ${colors.border}`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${colors.bg} ${colors.icon} mb-4 group-hover:scale-110 transition-transform`}>
                  <i className={`${card.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}